import React from 'react';
import styles from './Periods.module.scss';

const Periods = ({ liveStatistics }) => {
    const { homeTeamScore, awayTeamScore, periodScores } = liveStatistics;

    return (
        <div className={styles.scoreStatsContainer}>
            <div className={styles.periods}>
                <span className={styles.period}>T</span>
                {periodScores?.map(periodScore => (
                    <span key={periodScore.periodNumber} className={styles.period}>
                        {periodScore.periodNumber}
                    </span>
                ))}
            </div>
            <div className={styles.scoresContainer}>
                <div className={styles.scoreContainer}>
                    <span>{homeTeamScore}</span>
                    <span>{awayTeamScore}</span>
                </div>
                {periodScores?.map(periodScore => (
                    <div key={periodScore.periodNumber} className={styles.scoreContainer}>
                        <span> {periodScore.homeTeamScore}</span>
                        <span> {periodScore.awayTeamScore}</span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Periods;
